import type { ConsentSnapshot } from '@/Integrations/Consent/types';

export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

export function createDefaultSnapshot(): ConsentSnapshot {
  return {
    functional: true,
    analytics: false,
    marketing: false,
    source: 'default',
    updatedAt: Date.now(),
  };
}

export function createSnapshot(
  values: Pick<ConsentSnapshot, 'analytics' | 'marketing'>,
  raw?: unknown,
): ConsentSnapshot {
  return {
    functional: true,
    analytics: values.analytics,
    marketing: values.marketing,
    source: 'cmp',
    updatedAt: Date.now(),
    raw,
  };
}
